import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import * as utils from "../../../redux/reducers/utils";
import { ManufacturesDefaultDetails } from "../../../Constants/constant";
import { const_var, params } from "../../../redux/reducers/reducer";
import utilityStorageOptionsHelpers from "../../building_pricing/utility_pricing/utilityStorageOptions.helpers";
import leanToWallOptionHelpers from "../../lean_building_pricing/lenatoWallOptions.helpers";
import { setWainscotDefault } from "../building_color/wainscotColor.helper";
import { updateWallSelection } from "../../building_pricing/wall_pricing/wallPricing.helper";
export const fullyWallEnclosed = (state, { resetLeantoStoragePrice } = {}) => {
	const { params, const_var } = state;
	state.params.p_c_p_r = false;
	state.params.p_c_p_l = false;
	utils.update26GAUpgradePrice();
	if (state.isFullyEnclosedChecked) {
		state.params.p_f_w = "Close";
		state.params.p_b_w = "Close";
		state.params.p_l_w = "Close";
		state.params.p_r_w = "Close";
		state.params.p_f_w_f = state.params.p_f_w;
		utils.wallSelectionChangesForLNTBuilding(state, "all", true);
	} else {
		state.params.p_f_w = "Open";
		state.params.p_b_w = "Open";
		state.params.p_l_w = state.params.p_b_t != 2 ? "Open" : 1;
		state.params.p_r_w = state.params.p_b_t != 2 ? "Open" : 1;
		state.params.p_f_w_f = state.params.p_f_w;
		if (const_var.isLTBuilding == true) {
			// if front wall of center building is open and storage is added in front lean-to then will close the back wall of front lean-to
			if (params.add_storage_check_front == true && state.params.leanStyle.front === "gable" && state.params.p_f_w == "Open" && params.frontLeanStoragePosition == 0) {
				params.p_b_c_b_f_b = "Close";
				const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
				cuBuilding.UpdateFrontLean("walls");
				cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
			}
			// if back wall of center building is open and storage is added in back lean-to then will close the back wall of back lean-to
			if (params.add_storage_check_back == true && state.params.leanStyle.back === "gable" && state.params.p_b_w == "Open" && params.backLeanStoragePosition == 0) {
				params.p_b_c_b_b_b = "Close";
				const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
				cuBuilding.UpdateBackLean("walls");
				cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
			}
			if (params.add_storage_check == true && state.params.leanStyle.left === "gable" && state.params.p_l_w == "Open" && params.leftLeanStoragePosition == 0) {
				params.p_b_c_b_l_b = "Close";
				const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
				cuBuilding.UpdateLeftLean("walls");
				cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
			}
			if (params.add_storage_check_right == true && state.params.leanStyle.right === "gable" && state.params.p_r_w == "Open" && params.rightLeanStoragePosition == 0) {
				params.p_b_c_b_r_b = "Close";
				const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
				cuBuilding.UpdateRightLean("walls");
				cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
			}
		}

		const_var.UpdatedPriceData.insulation_price = undefined;
	}
	cuBuilding.BuildingUpdate(true, "centerwall");
	if (state.params.p_f_w === "Close" && state.params.p_r_w === "Close" && state.params.p_l_w === "Close" && state.params.p_b_w === "Close") {
		state.const_var.setSidesEndsWallOption = "close";
	} else if (state.params.p_f_w === "Open" && state.params.p_r_w === "Open" && state.params.p_l_w === "Open" && state.params.p_b_w === "Open" && state.params.p_c_p_l == false && state.params.p_c_p_r == false) {
		state.const_var.setSidesEndsWallOption = "open";
	}

	if (params.add_front_lean && params.add_storage_check_front) {
	}
	if (params.add_left_lean && params.add_storage_check) {
	}
	if (params.add_right_lean && params.add_storage_check_right) {
	}
	if (params.add_back_lean && params.add_storage_check_back) {
	}
	// utils.checkForExtraAddOnCheckedoption();

	const_var.UpdatedPriceData.roof_pitch_price_changed = true;
	const_var.UpdatedPriceData.right_wall_price_changed = true;
	const_var.UpdatedPriceData.left_wall_price_changed = true;
	const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
	const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
	const_var.UpdatedPriceData.front_wall_price_changed = true;
	const_var.UpdatedPriceData.back_wall_price_changed = true;
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	const_var.UpdatedPriceData.utility_price_changed = true;
	if (params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
	const_var.UpdatedPriceData.surcharge_amount = undefined;
	const_var.UpdatedPriceData.insulation_price = undefined;
	resetLeantoStoragePrice("frontLean");
	resetLeantoStoragePrice("leftLean");
	resetLeantoStoragePrice("rightLean");
	resetLeantoStoragePrice("backLean");
	cuBuilding.cP();
};

export const handleWallSelectonChangeValue = (state, e, wall, { removeStorage, resetLeantoStoragePrice } = {}) => {
	const { params, const_var } = state;
	var chkEndJtrim = false;
	var chkSideJtrim = false;
	const_var.onDragUtilityPriceUpdateCenterBuilding = false;
	if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
		chkEndJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
		chkSideJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
	}

	utils.update26GAUpgradePrice();

	if (wall === "front") {
		if ((state.params.cB_addStorage_check_left || state.params.cB_addStorage_check_right) && (e.target.value == "Half Dutch End" || e.target.value == "Half End")) removeStorage?.(state);

		state.params.p_f_w = e.target.value;
		state.params.p_f_w_f = state.params.p_f_w;
		params.dropdown_flagF = true;
		if (params.p_f_w != "Open" && params.p_f_w != "Close" && params.p_f_w != "Half Dutch End" && params.p_f_w != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.ManageDoorArrar["front"] = [];
		const_var.ManageGlobalComponent["front"] = [];
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		if (params.add_storage_check_front == true && state.params.leanStyle.front === "gable" && state.params.p_f_w != "Close" && params.frontLeanStoragePosition == 0) {
			const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
		} else {
			utils.wallSelectionChangesForLNTBuilding(state, "front", true);
		}
		resetLeantoStoragePrice?.("frontLean");
	} else if (wall === "back") {
		if ((state.params.cB_addStorage_check_left || state.params.cB_addStorage_check_right) && (e.target.value == "Half Dutch End" || e.target.value == "Half End")) removeStorage?.(state);

		state.params.p_b_w = e.target.value;
		params.dropdown_flagB = true;
		if (params.p_b_w != "Open" && params.p_b_w != "Close" && params.p_b_w != "Half Dutch End" && params.p_b_w != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.ManageDoorArrar["back"] = [];
		const_var.ManageGlobalComponent["back"] = [];
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		if (params.add_storage_check_back == true && state.params.leanStyle.back === "gable" && state.params.p_b_w != "Close" && params.backLeanStoragePosition == 0) {
			const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
		} else {
			utils.wallSelectionChangesForLNTBuilding(state, "back", true);
		}
		resetLeantoStoragePrice?.("backLean");
	} else if (wall === "left") {
		state.params.p_l_w = e.target.value;

		if (params.p_l_w != "Open" && params.p_l_w != "Close" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		const_var.checkPanelForLean.left = "";
		const_var.ManageDoorArrar["left"] = [];
		const_var.ManageGlobalComponent["left"] = [];
		state.params.a_c_p_l = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.common_left_lean_length_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;

		if (e.target.parentNode?.nextSibling?.innerText?.includes("1/2 Panel")) {
			state.params.p_c_p_l = true;
			state.params.a_c_p_l = true;
			const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.common_length_changed = true;
			const_var.UpdatedPriceData.common_left_lean_length_changed = true;
			const_var.UpdatedPriceData.surcharge_amount = undefined;
			const_var.UpdatedPriceData.certificate_price_changed = true;

			if (params.p_c_p_l == true && chkSideJtrim == true) {
				params.p_j_t = true;
			}
		} else {
			state.params.p_c_p_l = false;
		}
		if (params.add_storage_check == true && state.params.leanStyle.left === "gable" && state.params.p_l_w != "Close" && params.leftLeanStoragePosition == 0) {
			params.p_b_c_b_l_b = "Close";
			const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
		} else {
			utils.wallSelectionChangesForLNTBuilding(state, "left", true);
		}
		resetLeantoStoragePrice?.("leftLean");
	} else if (wall === "right") {
		state.params.p_r_w = e.target.value;

		if (params.p_r_w != "Open" && params.p_r_w != "Close" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		const_var.checkPanelForLean.right = "";
		const_var.ManageDoorArrar["right"] = [];
		const_var.ManageGlobalComponent["right"] = [];
		state.params.a_c_p_r = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.common_right_lean_length_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;

		if (e.target.parentNode?.nextSibling?.innerText?.includes("1/2 Panel")) {
			state.params.p_c_p_r = true;
			state.params.a_c_p_r = true;
			const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.common_length_changed = true;
			const_var.UpdatedPriceData.common_right_lean_length_changed = true;
			const_var.UpdatedPriceData.surcharge_amount = undefined;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			if (params.p_c_p_r == true && chkSideJtrim == true) {
				params.p_j_t = true;
			}
		} else {
			state.params.p_c_p_r = false;
		}
		if (params.add_storage_check_right == true && state.params.leanStyle.right === "gable" && state.params.p_r_w != "Close" && params.rightLeanStoragePosition == 0) {
			params.p_b_c_b_r_b = "Close";
			const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
		} else {
			utils.wallSelectionChangesForLNTBuilding(state, "right", true);
		}
		resetLeantoStoragePrice?.("rightLean");
	}

	if (
		state.params.p_v_w &&
		state.params.p_r_s == 3 &&
		state.params.p_f_w.toLowerCase() == "open" &&
		state.params.p_b_w.toLowerCase() == "open" &&
		state.params.p_l_w.toLowerCase() == "open" &&
		state.params.p_r_w.toLowerCase() == "open" &&
		ManufacturesDefaultDetails.AMERICAN_STEEL_CARPORTS.id == params.selectedManufactureId
	) {
		state.params.p_f_i = false;
		state.params.p_r_o = state.params.p_r_s == 3 ? state.params.p_r_o : false;
		state.params.p_c_i = false;
	}

	if (state.params.p_b_w != "Close" || state.params.p_f_w != "Close" || state.params.p_l_w != "Close" || state.params.p_r_w != "Close") {
		state.isFullyEnclosedChecked = false;
	} else {
		state.isFullyEnclosedChecked = true;
	}

	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;

	const_var.UpdatedPriceData.insulation_price_changed = true;

	const_var.UpdatedPriceData.roof_pitch_price_changed = true;
	if (params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
	if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
	const_var.UpdatedPriceData.surcharge_amount = undefined;
	cuBuilding.BuildingUpdate(true, "centerwall");
	if (e.target.value == "Half Dutch End" || e.target.value == "Half End") {
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
	}
	cuBuilding.cP();
};

export const dynamicWallOptions = (state, isFor) => {
	const { params, const_var } = state;

	state.const_var.a_p_d_a = state.const_var.a_p_d_a && typeof state.const_var.a_p_d_a === "object" ? state.const_var.a_p_d_a : {};
	if (!Array.isArray(state.const_var.a_p_d_a.panel)) {
		state.const_var.a_p_d_a.panel = [];
	}
	if (!Array.isArray(state.const_var.a_p_d_a.gable_end)) {
		state.const_var.a_p_d_a.gable_end = [];
	}

	state.p_l_r = {};
	state.p_l_rL = {};
	state.p_l_rR = {};
	state.b_p_r = {};
	state.b_p_rR = {};

	state.ends = {};
	state.sides = {};
	const_var.wallArray = { front: {}, back: {} };

	let showRemainingWallOption = true;
	let isOlderThen12June =
		const_var.crmSetting.is_Edit == true &&
		const_var.editAPIDataByResponse != undefined &&
		const_var.editAPIDataByResponse.data != undefined &&
		const_var.editAPIDataByResponse.data.main_created_at != undefined &&
		const_var.editAPIDataByResponse.data.main_created_at <= "2024-06-12"
			? true
			: false;

	if (!isOlderThen12June && (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97 || params.m_s_n == 13)) {
		showRemainingWallOption = false;
	}
	if (const_var.crmSetting.is_Edit == true) {
		if (const_var.editAPIDataByResponse.data != undefined && const_var.editAPIDataByResponse.data.created_at <= "2023-10-13") {
			showRemainingWallOption = true;
		}
	}
	// end wall selections
	state.ends["Open"] = "Open";
	if (state.const_var.a_p_d_a.gable_end != undefined && state.const_var.a_p_d_a.gable_end.length > 0) {
		if (state.const_var.a_p_d_a.gable_end[0].extended != 0 || state.const_var.a_p_d_a.gable_end[0].vertical_extended != 0) {
			state.ends["Gable"] = "Gable";
			state.ends["Extended Gable"] = "Extended Gable";
		} else {
			state.ends["Gable"] = "Gable";
		}
	}
	if (showRemainingWallOption == true) {
		state.ends["1/4 Closed"] = "One_Fourth_Close";
		state.ends["1/2 Closed"] = "Half_Close";
		state.ends["3/4 Closed"] = "Three_Fourth_Close";
	}
	if (showRemainingWallOption == false && (params.add_front_lean == true || params.add_back_lean == true)) {
		state.ends["1/4 Closed"] = "One_Fourth_Close";
		state.ends["1/2 Closed"] = "Half_Close";
		state.ends["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.ends["Closed"] = "Close";

	// vallues for front wall
	const_var.wallArray["front"]["Open"] = "Open";

	if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167 || params.m_s_n == 169 || params.m_s_n == 95) {
		const_var.wallArray["front"]["Half Dutch End"] = "Half Dutch End";
		const_var.wallArray["front"]["Half End"] = "Half End";
	}

	if (params.m_s_n == 1 || params.m_s_n == 155 || params.m_s_n == 162 || params.m_s_n == 17 || params.m_s_n == 186) {
		const_var.wallArray["front"]["Half End"] = "Half End";
	}

	if (state.const_var.a_p_d_a.gable_end != undefined && state.const_var.a_p_d_a.gable_end.length > 0) {
		if (state.const_var.a_p_d_a.gable_end[0].extended != 0 || state.const_var.a_p_d_a.gable_end[0].vertical_extended != 0) {
			const_var.wallArray["front"]["Gable"] = "Gable";
			const_var.wallArray["front"]["Extended Gable"] = "Extended Gable";
		} else {
			const_var.wallArray["front"]["Gable"] = "Gable";
		}
	}
	if (showRemainingWallOption == true) {
		const_var.wallArray["front"]["1/4 Closed"] = "One_Fourth_Close";
		const_var.wallArray["front"]["1/2 Closed"] = "Half_Close";
		const_var.wallArray["front"]["3/4 Closed"] = "Three_Fourth_Close";
	}
	if (showRemainingWallOption == false && params.add_front_lean == true) {
		const_var.wallArray["front"]["1/4 Closed"] = "One_Fourth_Close";
		const_var.wallArray["front"]["1/2 Closed"] = "Half_Close";
		const_var.wallArray["front"]["3/4 Closed"] = "Three_Fourth_Close";
	}
	const_var.wallArray["front"]["Closed"] = "Close";
	// vallues for back wall
	const_var.wallArray["back"]["Open"] = "Open";
	if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167 || params.m_s_n == 169 || params.m_s_n == 95) {
		const_var.wallArray["back"]["Half Dutch End"] = "Half Dutch End";
		const_var.wallArray["back"]["Half End"] = "Half End";
	}

	if (params.m_s_n == 1 || params.m_s_n == 155 || params.m_s_n == 162 || params.m_s_n == 17 || params.m_s_n == 186) {
		const_var.wallArray["back"]["Half End"] = "Half End";
	}

	if (state.const_var.a_p_d_a.gable_end != undefined && state.const_var.a_p_d_a.gable_end.length > 0) {
		if (state.const_var.a_p_d_a.gable_end[0].extended != 0 || state.const_var.a_p_d_a.gable_end[0].vertical_extended != 0) {
			const_var.wallArray["back"]["Gable"] = "Gable";
			const_var.wallArray["back"]["Extended Gable"] = "Extended Gable";
		} else {
			const_var.wallArray["back"]["Gable"] = "Gable";
		}
	}
	if (showRemainingWallOption == true) {
		const_var.wallArray["back"]["1/4 Closed"] = "One_Fourth_Close";
		const_var.wallArray["back"]["1/2 Closed"] = "Half_Close";
		const_var.wallArray["back"]["3/4 Closed"] = "Three_Fourth_Close";
	}
	if (showRemainingWallOption == false && params.add_back_lean == true) {
		const_var.wallArray["back"]["1/4 Closed"] = "One_Fourth_Close";
		const_var.wallArray["back"]["1/2 Closed"] = "Half_Close";
		const_var.wallArray["back"]["3/4 Closed"] = "Three_Fourth_Close";
	}
	const_var.wallArray["back"]["Closed"] = "Close";

	// side wall selections

	if (state.params.add_left_lean == true && state.params.continous_left_lean == false) {
		var calData = state.params.leanStyle.left === "gable" ? 0 : (state.params.lean_p_w * state.params.b_l_t_r_p) / 12;
		var finalHeight = state.params.p_h - (calData + state.params.lean_p_h);
		var calVal = Math.ceil(finalHeight / 3);
		var oneFourthValue = state.params.p_h / 4;
		if (state.const_var.a_p_d_a.panel.length > 0) {
			var startVal = calVal != 0 ? calVal - 1 : 0;
			if (calVal == 0) {
				state.p_l_rL["Open"] = "Open";
			} else {
				state.p_l_rL = {};
			}

			for (var i = startVal; i < Math.floor((state.params.p_h - 1) / 3); i++) {
				if (state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
					state.p_l_rL[" 1/2" + " Panel (1.5') "] = "Open";
				}
				if (i == 0) {
					state.p_l_rL[i + 1 + " Panel (3')"] = i + 1;
					if (state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
						state.p_l_rL[i + 1 + " 1/2" + " Panel (4.5') "] = i + 1;
					}
				} else {
					var fit_i = (i + 1) * 3;
					state.p_l_rL[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
					if (fit_i + 1.5 <= state.params.p_h && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
						state.p_l_rL[i + 1 + " 1/2" + " Panels (" + (fit_i + 1.5) + "')"] = i + 1;
					}
				}
			}
			if (!showRemainingWallOption) state.p_l_rL["Closed"] = "Close";
		} else {
			if (calVal == 0) {
				state.p_l_rL["Open"] = "Open";
			}
			state.p_l_rL["Closed"] = "Close";
		}

		if (showRemainingWallOption == true) {
			if (oneFourthValue >= finalHeight) {
				state.p_l_rL["1/4 Closed"] = "One_Fourth_Close";
			}
			if (2 * oneFourthValue >= finalHeight) {
				state.p_l_rL["1/2 Closed"] = "Half_Close";
			}
			if (3 * oneFourthValue >= finalHeight) {
				state.p_l_rL["3/4 Closed"] = "Three_Fourth_Close";
			}
			state.p_l_rL["Closed"] = "Close";
			if (params.p_l_w) {
				let isExsist = Object.keys(state.p_l_rL).find((key) => state.p_l_rL[key] == params.p_l_w);
				params.p_l_w = isExsist == undefined ? "Closed" : params.p_l_w;
			}
		}
	}
	if (state.params.add_right_lean == true && state.params.continous_right_lean == false) {
		var calData = state.params.leanStyle.right === "gable" ? 0 : (state.params.leanR_p_w * state.params.b_l_t_r_pR) / 12;
		var finalHeight = state.params.p_h - (calData + state.params.leanR_p_h);
		var calVal = Math.ceil(finalHeight / 3);
		var oneFourthValue = state.params.p_h / 4;
		if (state.const_var.a_p_d_a.panel.length > 0) {
			var startVal = calVal != 0 ? calVal - 1 : 0;
			if (calVal == 0) {
				state.p_l_rR["Open"] = "Open";
			} else {
				state.p_l_rR = {};
			}

			for (var i = startVal; i < Math.floor((state.params.p_h - 1) / 3); i++) {
				if (state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
					state.p_l_rR[" 1/2" + " Panel (1.5') "] = "Open";
				}
				if (i == 0) {
					state.p_l_rR[i + 1 + " Panel (3')"] = i + 1;
					if (state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
						state.p_l_rR[i + 1 + " 1/2" + " Panel (4.5') "] = i + 1;
					}
				} else {
					var fit_i = (i + 1) * 3;
					state.p_l_rR[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
					if (fit_i + 1.5 <= state.params.p_h && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
						state.p_l_rR[i + 1 + " 1/2" + " Panels (" + (fit_i + 1.5) + "')"] = i + 1;
					}
				}
			}
			if (!showRemainingWallOption) state.p_l_rR["Closed"] = "Close";
		} else {
			if (calVal == 0) {
				state.p_l_rR["Open"] = "Open";
			}
			state.p_l_rR["Closed"] = "Close";
		}

		if (showRemainingWallOption == true) {
			if (oneFourthValue >= finalHeight) {
				state.p_l_rR["1/4 Closed"] = "One_Fourth_Close";
			}
			if (2 * oneFourthValue >= finalHeight) {
				state.p_l_rR["1/2 Closed"] = "Half_Close";
			}
			if (3 * oneFourthValue >= finalHeight) {
				state.p_l_rR["3/4 Closed"] = "Three_Fourth_Close";
			}
			state.p_l_rR["Closed"] = "Close";
			if (params.p_r_w) {
				let isExsist = Object.keys(state.p_l_rR).find((key) => state.p_l_rR[key] == params.p_r_w);
				params.p_r_w = isExsist == undefined ? "Closed" : params.p_r_w;
			}
		}
	}

	state.p_l_r["Open"] = "Open";

	if (state.const_var.a_p_d_a.panel.length > 0) {
		for (var i = 0; i < Math.floor((state.params.p_h - 1) / 3); i++) {
			if (state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
				state.p_l_r[" 1/2" + " Panel (1.5') "] = "Open";
			}
			if (i == 0) {
				state.p_l_r[i + 1 + " Panel (3')"] = i + 1;
				if (state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
					state.p_l_r[i + 1 + " 1/2" + " Panel (4.5') "] = i + 1;
				}
			} else {
				var fit_i = (i + 1) * 3;
				state.p_l_r[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
				if (fit_i + 1.5 <= state.params.p_h && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
					state.p_l_r[i + 1 + " 1/2" + " Panels (" + (fit_i + 1.5) + "')"] = i + 1;
				}
			}
		}
	}
	if (showRemainingWallOption == true) {
		state.p_l_r["1/4 Closed"] = "One_Fourth_Close";
		state.p_l_r["1/2 Closed"] = "Half_Close";
		state.p_l_r["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.p_l_r["Closed"] = "Close";

	state.b_p_r["Open"] = "Open";
	if (state.params.p_r_s == "4" || state.params.p_r_s == "5") {
		var val = state.params.p_h - 5;
	} else {
		if (state.params.add_left_lean == true) {
			var val = state.params.lean_p_h;
			if (state.const_var.a_p_d_a.panel.length > 0) {
				for (var i = 0; i < Math.floor((val - 1) / 3); i++) {
					var fit_i = (i + 1) * 3;
					state.b_p_r[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
				}
			}
			if (showRemainingWallOption == true) {
				state.b_p_r["1/4 Closed"] = "One_Fourth_Close";
				state.b_p_r["1/2 Closed"] = "Half_Close";
				state.b_p_r["3/4 Closed"] = "Three_Fourth_Close";
			}
			state.b_p_r["Closed"] = "Close";
		}
		if (state.params.add_right_lean == true) {
			var val = state.params.leanR_p_h;
			state.b_p_rR["Open"] = "Open";

			if (state.const_var.a_p_d_a.panel.length > 0) {
				for (var i = 0; i < Math.floor((val - 1) / 3); i++) {
					var fit_i = (i + 1) * 3;
					state.b_p_rR[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
				}
			}
			if (showRemainingWallOption == true) {
				state.b_p_rR["1/4 Closed"] = "One_Fourth_Close";
				state.b_p_rR["1/2 Closed"] = "Half_Close";
				state.b_p_rR["3/4 Closed"] = "Three_Fourth_Close";
			}
			state.b_p_rR["Closed"] = "Close";
		}
	}

	if (params.add_right_lean == true && params.continous_right_lean == false) {
		state.jsonDataR = state.p_l_rR;
	} else {
		state.jsonDataR = state.p_l_r;
	}
	if (params.add_left_lean == true && params.continous_left_lean == false) {
		state.jsonDataL = state.p_l_rL;
	} else {
		state.jsonDataL = state.p_l_r;
		if (params.singleSlope) {
			const p_l_rs = {};
			p_l_rs["Open"] = "Open";
			let slopeHeight =
				const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
					? Math.floor((params.p_h - (Number(params.p_r_p) / 12) * params.p_w).toFixed(2))
					: Math.round((params.p_h - (Number(params.p_r_p) / 12) * params.p_w).toFixed(2));
			if (state.const_var.a_p_d_a.panel.length > 0) {
				for (var i = 0; i < Math.floor((state.params.p_h - (Number(params.p_r_p) / 12) * params.p_w - 1) / 3); i++) {
					if (state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
						p_l_rs[" 1/2" + " Panel (1.5') "] = "Open";
					}
					if (i == 0) {
						p_l_rs[i + 1 + " Panel (3')"] = i + 1;
						if (state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
							p_l_rs[i + 1 + " 1/2" + " Panel (4.5') "] = i + 1;
						}
					} else {
						var fit_i = (i + 1) * 3;
						p_l_rs[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
						if (fit_i + 1.5 <= slopeHeight - 1.5 && state.const_var.a_p_d_a.panel[0].cut_panel_cost != 0) {
							p_l_rs[i + 1 + " 1/2" + " Panels (" + (fit_i + 1.5) + "')"] = i + 1;
						}
					}
				}
			}

			if (showRemainingWallOption == true) {
				p_l_rs["1/4 Closed"] = "One_Fourth_Close";
				p_l_rs["1/2 Closed"] = "Half_Close";
				p_l_rs["3/4 Closed"] = "Three_Fourth_Close";
			}
			p_l_rs["Closed"] = "Close";

			state.jsonDataL = p_l_rs;
		}
	}

	if (state.params.add_right_lean == true) {
		Object.entries(state.jsonDataR).forEach(([key, value], index) => {
			if (key.includes("1/2 Panel") == true && index == 0) {
				delete state.jsonDataR[key];
			}
		});
	}
	if (state.params.add_left_lean == true) {
		Object.entries(state.jsonDataL).forEach(([key, value], index) => {
			if (key.includes("1/2 Panel") == true && index == 0) {
				delete state.jsonDataL[key];
			}
		});
	}
	if (state.params.p_v_w == true) {
		let newJsonDataL = {};
		let newJsonDataR = {};
		Object.entries(state.jsonDataL).forEach(([key, value]) => {
			if (key.includes("1/2 Panel") == false) {
				newJsonDataL[key] = value;
			}
		});
		state.jsonDataL = newJsonDataL;
		Object.entries(state.jsonDataR).forEach(([key, value]) => {
			if (key.includes("1/2 Panel") == false) {
				newJsonDataR[key] = value;
			}
		});
		state.jsonDataR = newJsonDataR;
	}

	if (const_var.crmSetting.is_Edit != true) {
		if (
			isFor != undefined &&
			((isFor == "addLeftLean" && state.params.add_left_lean != true) ||
				(isFor == "addRightLean" && state.params.add_right_lean != true) ||
				(isFor == "addFrontLean" && state.params.add_front_lean != true) ||
				(isFor == "addBackLean" && state.params.add_back_lean != true))
		) {
		} else {
			const_var.UpdatedPriceData.left_wall_price_changed = true;
			const_var.UpdatedPriceData.right_wall_price_changed = true;
		}
	}
};

export const toggleAllVerticalCheckboxChange = (state) => {
	const { params, const_var } = state;
	// if walls are vertical thn cut panel must be false
	if (state.params.p_v_w) {
		state.params.p_c_p_l = false;
		state.params.p_c_p_r = false;
	}
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const_var.UpdatedPriceData.right_wall_price_changed = true;
	const_var.UpdatedPriceData.left_wall_price_changed = true;
	const_var.UpdatedPriceData.front_wall_price_changed = true;
	const_var.UpdatedPriceData.back_wall_price_changed = true;
	const_var.UpdatedPriceData.utility_price_changed = true;
	const_var.UpdatedPriceData.front_utility_price_changed = true;
	const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
	const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
	const_var.UpdatedPriceData.roof_pitch_price_changed = true;
	if (state.c_m_a[params.p_b_t]?.wainscot_details?.length > 0) {
		setWainscotDefault(state.c_m_a, params, state.const_var.color);
	}
	if (params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
	const_var.UpdatedPriceData.surcharge_amount = undefined;
	state.const_var.b_I_g_n_e = "building-normal.jpg";
	state.const_var.b_T_t_L_u = "";
	if (params.add_left_lean == true) {
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		// const_var.UpdatedPriceData.color_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
		cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
		cuBuilding.UpdateLeftLean("walls");
	}
	if (params.add_front_lean == true) {
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		// const_var.UpdatedPriceData.color_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
		cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
		cuBuilding.UpdateFrontLean("walls");
	}
	if (params.add_back_lean == true) {
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		// const_var.UpdatedPriceData.color_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
		cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
		cuBuilding.UpdateBackLean("walls");
	}
	if (params.add_right_lean == true) {
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		// const_var.UpdatedPriceData.color_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
		cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
		cuBuilding.UpdateRightLean("walls");
	}
	if (params.add_right_lean == false && params.add_left_lean == false) {
		cuBuilding.cP();
	}
	dynamicWallOptions(state);
	cuBuilding.BuildingUpdate(true, "leanwall");
};

export const checkForFullEnclosedBuilding = (state) => {
	const { params, const_var } = state;
	if (state.params.p_b_c_b_f_b == "Close" && state.params.p_b_c_b_f_f == "Close" && state.params.p_b_c_b_f_l == "Close") {
		state.params.p_c_a_f_l_w = true;
	} else {
		state.params.p_c_a_f_l_w = false;
	}
	if (state.params.p_b_c_b_b_f == "Close" && state.params.p_b_c_b_b_b == "Close" && state.params.p_b_c_b_b_l == "Close") {
		state.params.p_c_a_b_l_w = true;
	} else {
		state.params.p_c_a_b_l_w = false;
	}
	if (state.params.p_b_c_b_l_f == "Close" && state.params.p_b_c_b_l_b == "Close" && state.params.p_b_c_b_l == "Close") {
		state.params.p_c_a_l_l_w = true;
	} else {
		state.params.p_c_a_l_l_w = false;
	}

	if (state.params.p_b_c_b_r_f == "Close" && state.params.p_b_c_b_r_b == "Close" && state.params.p_b_c_b_r == "Close") {
		state.params.p_c_a_r_l_w = true;
	} else {
		state.params.p_c_a_r_l_w = false;
	}
	if (state.params.p_c_a_l_l_w != true) {
		state.isFullyEnclosedCheckedForLeftLeanTo = false;
		state.isFullyOpenedCheckedForLeftLeanTo = true;
	} else {
		state.isFullyEnclosedCheckedForLeftLeanTo = true;
		state.isFullyOpenedCheckedForLeftLeanTo = false;
	}
	if (state.params.p_c_a_r_l_w != true) {
		state.isFullyEnclosedCheckedForRightLeanTo = false;
		state.isFullyOpenedCheckedForRightLeanTo = true;
	} else {
		state.isFullyEnclosedCheckedForRightLeanTo = true;
		state.isFullyOpenedCheckedForRightLeanTo = false;
	}
	if (state.params.p_c_a_f_l_w != true) {
		state.isFullyEnclosedCheckedForFrontLeanTo = false;
		state.isFullyOpenedCheckedForFrontLeanTo = true;
	} else {
		state.isFullyEnclosedCheckedForFrontLeanTo = true;
		state.isFullyOpenedCheckedForFrontLeanTo = false;
	}
	if (state.params.p_c_a_b_l_w != true) {
		state.isFullyEnclosedCheckedForBackLeanTo = false;
		state.isFullyOpenedCheckedForBackLeanTo = true;
	} else {
		state.isFullyEnclosedCheckedForBackLeanTo = true;
		state.isFullyOpenedCheckedForBackLeanTo = false;
	}
	if (
		params.p_f_w == "Half Dutch End" ||
		params.p_f_w == "Half End" ||
		params.p_b_w == "Half Dutch End" ||
		params.p_b_w == "Half End" ||
		params.p_f_w == "Close" ||
		params.p_b_w == "Close" ||
		params.p_l_w == "Close" ||
		params.p_r_w == "Close" ||
		params.p_b_c_b_l_f == "Close" ||
		params.p_b_c_b_l == "Close" ||
		params.p_b_c_b_r_f == "Close" ||
		params.p_b_c_b_r == "Close" ||
		params.p_b_c_b_f_f == "Close" ||
		params.p_b_c_b_f_b == "Close" ||
		params.p_b_c_b_f_l == "Close" ||
		params.p_b_c_b_b_f == "Close" ||
		params.p_b_c_b_b_b == "Close" ||
		params.p_b_c_b_b_l == "Close" ||
		params.add_storage_check == true ||
		params.add_storage_check_right == true ||
		params.add_storage_check_front == true ||
		params.add_storage_check_back == true ||
		params.p_u_c == true ||
		params.p_b_c_b_l_f == "Half Dutch End" ||
		params.p_b_c_b_l_f == "Half End" ||
		params.p_b_c_b_l_b == "Half Dutch End" ||
		params.p_b_c_b_l_b == "Half End" ||
		params.p_b_c_b_b_f == "Half Dutch End" ||
		params.p_b_c_b_b_f == "Half End" ||
		params.p_b_c_b_b_b == "Half Dutch End" ||
		params.p_b_c_b_b_b == "Half End" ||
		params.p_b_c_b_f_f == "Half Dutch End" ||
		params.p_b_c_b_f_f == "Half End" ||
		params.p_b_c_b_f_b == "Half Dutch End" ||
		params.p_b_c_b_f_b == "Half End" ||
		params.p_b_c_b_r_f == "Half Dutch End" ||
		params.p_b_c_b_r_f == "Half End" ||
		params.p_b_c_b_r_b == "Half Dutch End" ||
		params.p_b_c_b_r_b == "Half End"
	) {
		const_var.showWainscotJSX = true;
	} else {
		const_var.showWainscotJSX = false;
	}
	if (
		params.p_f_w != "Open" ||
		params.p_b_w != "Open" ||
		params.p_l_w != "Open" ||
		params.p_r_w != "Open" ||
		params.p_b_c_b_l_f != "Open" ||
		params.p_b_c_b_l != "Open" ||
		params.p_b_c_b_r_f != "Open" ||
		params.p_b_c_b_r != "Open" ||
		params.p_b_c_b_f_f != "Open" ||
		params.p_b_c_b_f_b != "Open" ||
		params.p_b_c_b_f_l != "Open" ||
		params.p_b_c_b_b_f != "Open" ||
		params.p_b_c_b_b_b != "Open" ||
		params.p_b_c_b_b_l != "Open" ||
		params.p_u_c == true ||
		params.add_storage_check == true ||
		params.add_storage_check_right == true ||
		params.add_storage_check_front == true ||
		params.add_storage_check_back == true ||
		params.p_c_p_l == true ||
		params.p_c_p_r == true
	) {
		const_var.showWallColorJSX = true;
	} else {
		const_var.showWallColorJSX = false;
	}
};
export const fullWallOpened = (state, action) => {
	let UpdateOpenAction = "";
	const_var.onDragUtilityPriceUpdateCenterBuilding = false;
	if (action.value == "openCenterBuldingWalls") {
		state.isFullyEnclosedChecked = false;
		if (params.cB_addStorage_check_left || params.cB_addStorage_check_right) {
			params.cB_addStorage_check_left = false;
			params.cB_addStorage_check_right = false;
		}
		state.params.p_u_c = false;
		state.params.nostorage = true;
		// console.log('FULLYOPENED');
		const_var.insulationPriceJson.insulation_wall = {};
		const_var.UpdatedPriceData.insulation_price_changed = true;
		utils.update26GAUpgradePrice();
		updateWallSelection("center", true);

		if (state.params.p_v_w && state.params.p_r_s == 3 && ManufacturesDefaultDetails.AMERICAN_STEEL_CARPORTS.id == params.selectedManufactureId) {
			state.params.p_f_i = false;
			state.params.p_r_o = state.params.p_r_s == 3 ? state.params.p_r_o : false;
			state.params.p_c_i = false;
		}

		centerBuildingsWallOptionsHelpers.closeCenterWalls(state, {
			resetLeantoStoragePrice: (leanType) => utilityStorageOptionsHelpers.resetLeanToStoragePrice(state, leanType)
		});
		UpdateOpenAction = state.isFullyEnclosedChecked + state.params.p_u_c;
	} else if (action.value == "openFrontLeanWalls") {
		state.isFullyOpenedCheckedForFrontLeanTo = true;
		state.isFullyEnclosedCheckedForFrontLeanTo = false;
		state.params.add_storage_check_front = false;
		state.newColor = "";
		const_var.insulationArrayForLeantoFront.insulation_wall = {};
		const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;

		utils.update26GAUpgradePrice("front");
		updateWallSelection("frontLean", true);
		leanToWallOptionHelpers.closeFrontLeanWalls(state);
	} else if (action.value == "openLeftLeanWalls") {
		state.isFullyOpenedCheckedForLeftLeanTo = true;
		state.isFullyEnclosedCheckedForLeftLeanTo = false;
		state.params.add_storage_check = false;
		state.newColor = "";
		const_var.insulationArrayForLeantoLeft.insulation_wall = {};
		const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;

		utils.update26GAUpgradePrice("left");
		updateWallSelection("leftLean", true);

		leanToWallOptionHelpers.closeLeftLeanWalls(state);

		UpdateOpenAction = state.isFullyOpenedCheckedForLeftLeanTo + state.isFullyEnclosedCheckedForLeftLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.params.add_storage_check;
	} else if (action.value == "openRightLeanWalls") {
		state.isFullyOpenedCheckedForRightLeanTo = true;
		state.params.add_storage_check_right = false;
		state.isFullyEnclosedCheckedForRightLeanTo = false;
		state.newColor = "";
		const_var.insulationArrayForLeantoRight.insulation_wall = {};
		const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;

		utils.update26GAUpgradePrice("right");
		updateWallSelection("rightLean", true);
		leanToWallOptionHelpers.closeRightLeanWalls(state);

		UpdateOpenAction = state.isFullyOpenedCheckedForRightLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.isFullyEnclosedCheckedForLeftLeanTo + state.params.add_storage_check_right;
	} else if (action.value == "openBackLeanWalls") {
		state.isFullyOpenedCheckedForBackLeanTo = true;
		state.isFullyEnclosedCheckedForBackLeanTo = false;
		state.params.add_storage_check_back = false;
		state.newColor = "";
		const_var.insulationArrayForLeantoBack.insulation_wall = {};
		const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;

		utils.update26GAUpgradePrice("back");
		updateWallSelection("backLean", true);
		leanToWallOptionHelpers.closeBackLeanWalls(state);

		UpdateOpenAction = state.isFullyOpenedCheckedForBackLeanTo + state.isFullyEnclosedCheckedForBackLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.params.add_storage_check_back;
	}

	if (state.params.p_f_w === "Close" && state.params.p_r_w === "Close" && state.params.p_l_w === "Close" && state.params.p_b_w === "Close") {
		const_var.setSidesEndsWallOption = "close";
	} else if (
		state.params.p_f_w === "Open" &&
		state.params.p_r_w === "Open" &&
		state.params.p_l_w === "Open" &&
		state.params.p_b_w === "Open" &&
		state.params.p_c_p_l == false &&
		state.params.p_c_p_r == false &&
		params.p_c_p_l == false &&
		params.p_c_p_r == false
	) {
		const_var.setSidesEndsWallOption = "open";
	} else {
		const_var.setSidesEndsWallOption = "partial";
	}
	return {
		...state,

		newColor: action
	};
};
export const fullWallClosed = (state, action) => {
	let UpdateCloseAction = "";
	const_var.onDragUtilityPriceUpdateCenterBuilding = false;
	const_var.check_siding_material_price = false;
	if (action.value == "closeCenterBuldingWalls") {
		state.isFullyEnclosedChecked = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		utils.update26GAUpgradePrice();
		centerBuildingsWallOptionsHelpers.closeCenterWalls(state, {
			resetLeantoStoragePrice: (leanType) => utilityStorageOptionsHelpers.resetLeanToStoragePrice(state, leanType)
		});
		UpdateCloseAction = state.isFullyEnclosedChecked + state.isFullyOpenedChecked;
	}
	if (action.value == "closeFrontLeanWalls") {
		state.isFullyEnclosedCheckedForFrontLeanTo = true;
		state.isFullyOpenedCheckedForFrontLeanTo = false;
		const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;

		utils.update26GAUpgradePrice("front");
		leanToWallOptionHelpers.closeFrontLeanWalls(state);
	} else if (action.value == "closeLeftLeanWalls") {
		state.isFullyEnclosedCheckedForLeftLeanTo = true;

		state.isFullyOpenedCheckedForLeftLeanTo = false;
		const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;

		utils.update26GAUpgradePrice("left");
		leanToWallOptionHelpers.closeLeftLeanWalls(state);
		UpdateCloseAction = state.isFullyOpenedCheckedForLeftLeanTo + state.isFullyEnclosedCheckedForLeftLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.params.add_storage_check;
	} else if (action.value == "closeRightLeanWalls") {
		state.isFullyEnclosedCheckedForRightLeanTo = true;

		state.isFullyOpenedCheckedForRightLeanTo = false;
		const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;

		utils.update26GAUpgradePrice("right");
		leanToWallOptionHelpers.closeRightLeanWalls(state);
		UpdateCloseAction = state.isFullyEnclosedCheckedForRightLeanTo + state.isFullyOpenedCheckedForRightLeanTo + state.params.add_storage_check_right;
	} else if (action.value == "closeBackLeanWalls") {
		state.isFullyEnclosedCheckedForBackLeanTo = true;

		state.isFullyOpenedCheckedForBackLeanTo = false;
		const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;

		utils.update26GAUpgradePrice("back");
		leanToWallOptionHelpers.closeBackLeanWalls(state);
		UpdateCloseAction = state.isFullyOpenedCheckedForBackLeanTo + state.isFullyEnclosedCheckedForBackLeanTo + state.isFullyEnclosedCheckedForRightLeanTo + state.params.add_storage_check_back;
	}
	if (state.params.p_f_w === "Close" && state.params.p_r_w === "Close" && state.params.p_l_w === "Close" && state.params.p_b_w === "Close") {
		const_var.setSidesEndsWallOption = "close";
	} else if (state.params.p_f_w === "Open" && state.params.p_r_w === "Open" && state.params.p_l_w === "Open" && state.params.p_b_w === "Open" && state.params.p_c_p_l == false && state.params.p_c_p_r == false) {
		const_var.setSidesEndsWallOption = "open";
	} else {
		const_var.setSidesEndsWallOption = "partial";
	}

	return {
		...state,
		action
	};
};
export const handleCutPanelWall = (state, action) => {
	let panelRendr = "";
	var chkEndJtrim = false;
	var chkSideJtrim = false;
	if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
		chkEndJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
		chkSideJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
	}
	if (action.key == "leftCutPanel") {
		state.params.p_c_p_l = action.value;
		state.params.a_c_p_l = true;
		const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		panelRendr = state.params.p_c_p_l + action.key;
		if (params.p_c_p_l == true && chkSideJtrim == true) {
			params.p_j_t = true;
		}
	} else if (action.key == "rightCutPanel") {
		state.params.p_c_p_r = action.value;
		state.params.a_c_p_r = true;
		const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		panelRendr = state.params.p_c_p_r + action.key;
		if (params.p_c_p_r == true && chkSideJtrim == true) {
			params.p_j_t = true;
		}
	}

	const_var.UpdatedPriceData.insulation_price = undefined;
	cuBuilding.BuildingUpdate(true, "centerwall");
	cuBuilding.cP();
	return {
		...state,
		action
	};
};
export const setActiveBuildingWall = (state, action, cuComponent) => {
	state.params.activeWall = action.value;
	state.const_var.focusedSection = cuComponent.wallnameBySec[action.value];

	if (state.const_var.focusedSection == "center" || state.const_var.focusedSection == "") {
		const_var.wallSelection.leanToWall = "select";
	} else {
		const_var.wallSelection.centerBuildingWall = "select";
	}

	return {
		...state,
		action
	};
};
const centerBuildingsWallOptionsHelpers = {
	closeCenterWalls: fullyWallEnclosed,
	applyCenterWallSelection: handleWallSelectonChangeValue,
	syncCenterWallOptions: dynamicWallOptions,
	syncCenterFullEnclosure: checkForFullEnclosedBuilding,
	applyAllVerticalWalls: toggleAllVerticalCheckboxChange,
	reducerBindings: {
		dynamicWallOptions
	}
};

export default centerBuildingsWallOptionsHelpers;
